﻿<template>
    <!-- one row: the price per age category, who is joining (a dropdown like the added add-on's in basket_item.vue,
         everyone selected by default) and the Add button -->
    <div class="ao-select">
        <p class="ao-prices">
            <span v-for="category in Price_Categories()" :key="category.name">{{category.name}} <strong>{{category.price}}</strong></span>
        </p>

        <div class="ci-items ao-who" v-click-away="Close_Passenger_List">
            <button type="button" class="ci-chip is-button" :disabled="Addon_In_Basket() || addingAddon" :aria-expanded="isOpen_Passenger_List" :aria-controls="Control_Name(-1)" @click="isOpen_Passenger_List = !isOpen_Passenger_List">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" /><circle cx="12" cy="7" r="4" /></svg>
                {{Passenger_Count_Text()}}
                <svg class="ci-chevron" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 9l6 6 6-6" /></svg>
            </button>
            <div :id="Control_Name(-1)" class="ci-popover" :hidden="!isOpen_Passenger_List">
                <p class="ci-popover-title">Who is joining?</p>
                <ul>
                    <li v-for="(passenger, index) in passengers" :key="index">
                        <label class="pp-check" :for="Control_Name(index)">
                            <input :id="Control_Name(index)" type="checkbox" :checked="checkTickBox(Passenger_Selected(index))" class="focus:ring-action h-4 w-4 text-action border-grey-light rounded" @change="Toggle_Passenger(index)">
                            <span>{{passenger.first_name || ('Passenger ' + (index + 1))}}</span>
                            <small class="ao-who-price">{{Get_Price(passenger)}}</small>
                        </label>
                    </li>
                </ul>
            </div>
        </div>

        <div class="ao-add">
            <button v-if="Addon_In_Basket() && !addingAddon" type="button" class="ao-added" disabled>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6L9 17l-5-5" /></svg>
                Added
            </button>
            <button v-else type="button" class="button button-pink-book small ao-add-btn" :class="{ 'is-adding': addingAddon }" :disabled="addingAddon || selected_passengers.length == 0" :aria-busy="addingAddon" :title="selected_passengers.length == 0 ? 'Select at least one passenger' : ''" @click="add_AddOn()">
                <svg v-if="addingAddon" class="ts-spinner" viewBox="0 0 24 24" fill="none" aria-hidden="true"><circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="3" opacity="0.25" /><path d="M22 12a10 10 0 0 0-10-10" stroke="currentColor" stroke-width="3" stroke-linecap="round" /></svg>
                {{ addingAddon ? 'Adding to trip…' : 'Add to trip' }}
            </button>
        </div>
    </div>
</template>

<script lang="ts" src="./select_passengers.ts"></script>